import { Item } from "src/services/item/item.interface";
import { Rack, rackToString } from "src/services/item/rack.interface";
import { Subscription } from "src/services/subscription/subscription";
import { User, userToString } from "src/services/user/user.interface";
import { Vehicle, vehicleToString } from "src/services/item/vehicle.interface";
import { baseLocationToString } from "src/services/subscription/base-locations.enum";

export interface LabelContent {
  footer?: string;
  lines: string[];
  qrPayload: string;
}

const doNotRemoveWarning = "Do not remove this label";

export function buildItemLabelContent(
  item: Item,
  user: User | undefined,
  subscription: Subscription | undefined,
): LabelContent {
  const lines = [userToString(user), baseLocationToString(subscription?.baseLocation)];

  if (item?.numberId) {
    lines.push(`#${item.numberId}`);
  }

  return {
    footer: doNotRemoveWarning,
    lines: lines.filter((line) => !!line),
    qrPayload: JSON.stringify({ itemId: item?.id }),
  };
}

export function buildRackLabelContent(rack: Rack): LabelContent {
  return {
    footer: doNotRemoveWarning,
    lines: [rackToString(rack)],
    qrPayload: JSON.stringify(rack),
  };
}

export function buildVehicleLabelContent(vehicle: Vehicle): LabelContent {
  return {
    footer: doNotRemoveWarning,
    lines: [vehicleToString(vehicle)],
    qrPayload: JSON.stringify(vehicle),
  };
}
